import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { User } from '../../types/models';

type ProtectedRouteProps = {
  children: React.ReactNode;
  allowedRoles?: User['role'][];
};

export const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { user, isAuthLoading } = useAuth(); // <-- Dodajemy isAuthLoading

  // Jeśli wciąż weryfikujemy, kto jest zalogowany, nic nie rób
  if (isAuthLoading) {
    return <div>Sprawdzanie uprawnień...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/brak-dostepu" replace />;
  }

  return <>{children}</>;
};